import { token } from '@atlaskit/tokens';
import ScrollableContainer from '@databases/layout/ScrollableContainer';
import { isStandalone } from '@databases/modes';
import styled from 'styled-components';

const DatabaseContentWrapper = styled(ScrollableContainer)<{
  isTableLayout?: boolean;
}>`
  box-sizing: border-box;
  min-height: 0;
  overflow: visible;
  padding-bottom: ${(props) =>
    props.isTableLayout && isStandalone() ? token('space.100', '8px') : 0};

  #add-entry-quick-calc-container {
    padding-bottom: ${(props) =>
      props.isTableLayout && isStandalone() ? token('space.100', '8px') : 0};
  }
`;

export default DatabaseContentWrapper;
